/**
 * Feature Flags Configuration for Branon Std+1 (Grade 11-12)
 * Master switches here + region-specific gating via regionConfig.
 */

import { isFeatureEnabled, getExamsForStudent } from './regionConfig';

export const FEATURES = {
  /** Master switch for chatbot. Region + plan checks layered on top. */
  CHATBOT: true,
  /** Master switch for practice tests (exam-style MCQ). */
  PRACTICE_TEST: true,
} as const;

/**
 * Plan + region-based chatbot enablement.
 * Chatbot requires: master switch ON + region allows it + premium plan.
 */
export function isChatbotEnabledForPlan(planType?: 'core' | 'premium'): boolean {
  return FEATURES.CHATBOT && isFeatureEnabled('showChatbot') && planType === 'premium';
}

/**
 * Check if the Exam Simulator is available for this student.
 * Requires: master switch ON + region allows it + at least one exam configured for the student's grade/board.
 */
export function isPracticeTestEnabled(grade: number, board?: string): boolean {
  return FEATURES.PRACTICE_TEST && isFeatureEnabled('showExamPrep') && getExamsForStudent(grade, board).length > 0;
}
